var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-amap"},[_c('div',{ref:"map-container",staticClass:"amap",attrs:{"id":"container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }